import { SystemViewEnum } from '@/modules/Settings/types/system.types.ts';

export enum GeofenceCategoryEnum {
  INACTIVE = 'inactive',
  RED_ZONE = 'red-zone',
  WORK_ZONE = 'work-zone',
}

export type GetGeofencesServiceProps = {
  setCurrentGeofenceId: (id: string) => void;
  setGeofences: (geofences: GeofenceProps[], isFetching: boolean) => void;
};

export type CreateGeofencesServiceProps = {
  geofenceCategory: GeofenceCategoryEnum;
  geofenceName: string;
  maxHeight: number;
  points: Point[];
  systemView: SystemViewEnum;
};

export type UpdateGeofencesServiceProps = CreateGeofencesServiceProps & {
  geofenceResName: string;
  status: GeofenceStatusEnum;
  systemView: SystemViewEnum;
};

export type UpdateGeofenceServiceResponse = {
  creationTime: {
    epochTime: number;
  };
  floorResName: string;
  geofenceCategory: string;
  geofenceName: string;
  geofenceResName: string;
  lastUpdateTime: {
    epochTime: number;
  };
  status: string;
};

export type GeofencesRootProps = {
  page: GeofencesPage;
  results: GeofenceProps[];
};

export type GeofencesPage = {
  hasNext: boolean;
  pageItemsCount: number;
};

export type GeofenceProps = {
  circle?: Circle;
  creationTime?: number;
  floorResName: string;
  geofenceCategory: GeofenceCategoryEnum;
  geofenceName: string;
  geofenceResName: string;
  id?: string;
  isTriggerBased?: boolean;
  lastUpdateTime?: number;
  localTimezoneOffset?: number;
  operationalPeriod?: OperationalPeriod;
  polygon?: Polygon;
  renderingState?: GeofenceRenderingStateEnum;
  selected?: boolean;
  status?: GeofenceStatusEnum;
  visible?: boolean;
};

export type NewApiGeofenceProps = {
  accountResName: string;
  circle?: Circle;
  floorResName: string;
  geofenceCategory: GeofenceCategoryEnum;
  geofenceCreationEpochTime: number;
  geofenceName: string;
  geofenceResName: string;
  lastGeofenceUpdateEpochTime: number;
  operatingDayEndTime?: string;
  operatingDaysOfWeek?: string[];
  operatingDayStartTime?: string;
  operationalPeriodEndEpochTime?: number;
  operationalPeriodStartEpochTime?: number;
  polygonMaxHeight: number;
  polygonPoints: { x: number; y: number; z: number }[];
  siteResName: string;
  SK: string;
  status: GeofenceStatusEnum;
  statusChangeNotifications: null;
};

export enum GeofenceStatusEnum {
  ACTIVE = 'active',
  DELETED = 'deleted',
  INACTIVE = 'inactive',
}

export enum GeofenceRenderingStateEnum {
  TRIGGERED = 'triggered',
  DORMANT = 'dormant',
}

export type Polygon = {
  maxHeight?: number;
  points: Point[];
};

export type Point = {
  x: number | string;
  y: number | string;
  z: number | string;
};

export interface Circle {
  center: Center;
  maxHeight: number;
  radius: number;
}

export interface Center extends Point {}

export type OperationalPeriod = {
  operatingDayEndTime: string;
  operatingDaysOfWeek: string[];
  operatingDayStartTime: string;
  periodEndDate: PeriodDateProps;
  periodStartDate: PeriodDateProps;
};

export type PeriodDateProps = {
  epochTime: number;
};

export type CoordinateValueInputProps = {
  className?: string;
  defaultValue: null | Omit<Point, 'z'> | undefined;
  error?: string;
  onChange: (defaultValue: Omit<Point, 'z'>) => void;
};
